import {
  ProfessorAreaAssignmentAttemptEdit,
  ProfessorAreaAssignmentAttemptShow
} from 'pages/professor_area/classrooms/components/TabAssignments/assignments/assignment_attempts';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'professor_area/classroom_assignments/attempts',
  pathTemplate:
    'professor_area/classrooms/:classroomId/evaluations/:evaluationId/attempts',
  label: 'Atividade do aluno',
  show: ProfessorAreaAssignmentAttemptShow,
  edit: ProfessorAreaAssignmentAttemptEdit,
  actions: ['show', 'edit', 'list'],
  parentName: 'professor_area',
  route:
    'professor_area/classrooms/:classroomId/assignments/:evaluationId/attempt'
};

export default generateResources(resource);
